import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Header, Modal } from 'semantic-ui-react';
import { segmapSchema } from '../data/model';
import { getFilteredSegmap, getSegmap, getSegmapList, getSegmapParams } from '../data/selectors';
import { cloneSegmapFunction, editSegmapFunction, saveSegmapFunction, setTogglesForEdit } from '../components/commomFunctions';
import FormContent from './formContent';

const SegmapFormWrapper = (props) => {
    const dispatch = useDispatch();
    const segmap = useSelector(state => getSegmap(state, props));
    const segmapData = useSelector(state => getFilteredSegmap(state));
    const params = useSelector(state => getSegmapParams(state, props));
    const segmaplist = useSelector(state => getSegmapList(state, props));

    const [toggles, setToggles] = useState({
        ws: 'no',
        cust: 'no',
        loc: 'no',
        transType: 'no',
        cashBankMap: 'no'
    });

    const setToggle = (key, value) => {
        setToggles(prev => ({ ...prev, [key]: value }));
    };

    const [savedSegmapId, setSavedSegmapId] = useState(false);
    const [duplicateModal, setDuplicateModal] = useState({ open: false, msg: "" });
    const [cloneModal, setCloneModal] = useState({ open: false, msg: "" });

    useEffect(() => {
        if (props.match.path === '/segmap/edit/:id' || props.match.path === '/segmap/clone/:id') {
            let id = props.match.params.id;
            let obj = segmaplist[id];
            setTogglesForEdit(obj, setToggles);
        }
    }, []);

    const saveSegmap = (values) => {
        if (props.match.path === '/segmap/create') {
            saveSegmapFunction(values, toggles, setSavedSegmapId, dispatch, props);
        }
        if (props.match.path === '/segmap/edit/:id') {
            editSegmapFunction(values, toggles, setSavedSegmapId, dispatch, props);
        }
        if (props.match.path === '/segmap/clone/:id') {
            cloneSegmapFunction(values, toggles, setSavedSegmapId, dispatch, props, segmapData, setDuplicateModal);
        }
    };

    return (
        <>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        {params.title}
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Fill in the segment mapping details below.
                    </div>
                </div>
            </div>
            <Formik
                id="segmapForm"
                initialValues={segmap}
                validationSchema={segmapSchema}
                onSubmit={(values) => saveSegmap(values)}
                render={({ handleSubmit, resetForm, values, setFieldValue }) => (
                    <FormContent
                        handleSubmit={handleSubmit}
                        resetForm={resetForm}
                        values={values}
                        setFieldValue={setFieldValue}
                        routeProps={props}
                        toggles={toggles}
                        setToggle={setToggle}
                        savedSegmapId={savedSegmapId}
                        cloneModal={cloneModal}
                        setCloneModal={setCloneModal}
                    />
                )}
            />
            <Modal open={duplicateModal.open} size="mini">
                <Modal.Header>Mapping Status</Modal.Header>
                <Modal.Content>
                    <p>{"Mapping Already Exists"}</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button type="button" positive onClick={() => setDuplicateModal({ open: false, msg: "" })}>Close</Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default SegmapFormWrapper;
